<template>
    <div>
        <fusioncharts
            type="line"
            :width="width"
            :height="height"
            :dataSource="dataSource">
        </fusioncharts>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: [Array, Object],
                required: true,
            },
            caption: {
                type: String,
                default: ""
            },
            bgColor: {
                type: String,
                default: "#edf2f7"
            },
            width: {
                type: [Number, String],
                default: "100%"
            },
            height: {
                type: [Number, String],
                default: 270
            }
        },

        computed: {
            dataSource() {
                return {
                    chart: {
                        bgColor: this.bgColor,
                        caption: this.caption,
                        theme: "fusion"
                    },
                    data: this.data
                }
            }
        },
    }
</script>